export const environment = {
  production: true,
  connection: {
    name: 'LH Südburgenland Softline',
    host: 'https://softline-test.rlhsued.at/',
    port: 443,
    basePath: '/api'
  },
  androidUpdateRepository: ''
};
